import { Box } from "@material-ui/core"
import { FormikProps } from "formik"
import { HourReportFormState } from "../../schemas"
import { getHHmmFromDate } from "../../utils"
import IntervalEntryFields from "../IntervalEntryFields"
import { useTranslation } from "react-i18next"

export const IntervalEntry = ({ formik }: Props) => {
  const { t } = useTranslation("hour-report")
  const { values, touched, errors, setValues } = formik
  if (values.method !== "interval") return null

  const handleChange = (field: "startTime" | "endTime", date: Date | null) => {
    if (!date) {
      setValues({ ...values, [field]: "" })
      return
    }

    formik.validateField(field)
    formik.setTouched({ ...formik.touched, [field]: true })

    const HHmm = getHHmmFromDate({
      date,
      midnightAs24Hour: field === "endTime",
    })

    setValues((prevValues) => {
      return {
        ...prevValues,
        [field]: HHmm,
      }
    })
  }

  const startTimeTouched = "startTime" in touched ? touched.startTime : false
  const endTimeTouched = "endTime" in touched ? touched.endTime : false
  const startTimeError = "startTime" in errors ? errors.startTime : undefined
  const endTimeError = "endTime" in errors ? errors.endTime : undefined
  const isStartTimeError = startTimeTouched && Boolean(startTimeError)
  const isEndTimeError = endTimeTouched && Boolean(endTimeError)
  const startTimeErrorText = isStartTimeError ? startTimeError : undefined
  const endTimeErrorText = isEndTimeError ? endTimeError : undefined
  const durationDescription = (hours: number, minutes: number) =>
    t("form.duration", { defaultValue: "Time used: {{hours}}h {{minutes}}m", hours, minutes })

  return (
    <Box mt={5}>
      <IntervalEntryFields
        date={values.date}
        start={values.startTime}
        onStartChange={(date) => handleChange("startTime", date)}
        startLabel={t("form.startTime", { defaultValue: "Start Time" })}
        startError={startTimeErrorText}
        end={values.endTime}
        onEndChange={(date) => handleChange("endTime", date)}
        endLabel={t("form.endTime", { defaultValue: "End Time" })}
        endError={endTimeErrorText}
        durationDescription={durationDescription}
      />
    </Box>
  )
}

type Props = {
  formik: FormikProps<HourReportFormState>
}
